import { useEffect, useState } from "react";
import { setAnalyticsTimeframe, setPeriodTimeFrame, setPublisherId } from "../context";
import { axiosInstance } from "lib/axios";
import { useDispatch, useSelector } from "react-redux";
import { analyticsAPI } from "services/apis.service";

export function usePublisherAnalytics() {
  const [publisherEngagement, setPublisherEngagement] = useState(null);
  const [topArticles, setTopArticles] = useState(null);
  const [topicPercentage, setTopicPercentage] = useState(null);
  const [topAuthors, setTopAuthors] = useState(null);
  const [searchTerms, setSearchTerms] = useState(null);
  const [demographics, setDemographics] = useState(null);
  const [averageClicks, setAverageClicks] = useState(null);
  const [clickThroughRate, setClickThroughRate] = useState(null);
  
  const [isLoadingEngagement, setIsLoadingEngagement] = useState(true);
  const [isLoadingTopArticles, setIsLoadingTopArticles] = useState(true);
  const [isLoadingTopicPercentage, setIsLoadingTopicPercentage] = useState(true);
  const [isLoadingSearchTerms, setIsLoadingSearchTerms] = useState(true);
  const [isLoadingDemographics, setIsLoadingDemographics] = useState(true);
  const [isLoadingAverageClicks, setIsLoadingAverageClicks] = useState(true);
 
  const dispatch = useDispatch();
  const { analyticsTimeframe, periodTimeFrame, publisherId, publisherName, publisherRole, roles } = useSelector((state) => state.publisher);    
  
  const getPublisherEngagement = async () => {
    try {
        setIsLoadingEngagement(true);
        const response = await axiosInstance.post(analyticsAPI.getPublisherEngagement, {
            dataFrequencyId: analyticsTimeframe,
            publisherId: publisherId
          });
        setPublisherEngagement(response.data);
    } catch (error) {
        console.error(error);
    } finally {
        setIsLoadingEngagement(false);
    }
  };

  const getPublishersEngagementTopArticles = async () => {
    try {
        setIsLoadingTopArticles(true);
        const response = await axiosInstance.post(analyticsAPI.getPublishersTopArticles, {
          "filter": "",
          "sortExpression": "",
          "paginate": false,
          "pageIndex": 0,
          "pageSize": 0,
          "dataFrequencyId": analyticsTimeframe,
          "publisherId": publisherId
        });
        setTopArticles(response.data);
    } catch (error) {
        console.error(error);
    } finally {
        setIsLoadingTopArticles(false);
    }
  };

  const getPublisherEngagementTopicPercantage  = async () => {
    try {
        setIsLoadingTopicPercentage(true);
        const response = await axiosInstance.post(analyticsAPI.getPublisherEngagementTopicPercantage, {
            dataFrequencyId: analyticsTimeframe,
            publisherId: publisherId
          });
        setTopicPercentage(response.data);
    } catch (error) {
        console.error(error);
    } finally {
        setIsLoadingTopicPercentage(false);
    }
  };

  const getPublisherEngagementSearchTerms = async () => {
    try {
        setIsLoadingSearchTerms(true);
        const response = await axiosInstance.post(analyticsAPI.getPublisherEngagementSearchTerms, {
            dataFrequencyId: analyticsTimeframe,
            publisherId: publisherId
          });
        setSearchTerms(response.data.searchTerm);
    } catch (error) {
        console.error(error);
    } finally {
        setIsLoadingSearchTerms(false);
    }
  };

  const getPublisherEngagementDemographics = async () => {
    try {
        setIsLoadingDemographics(true);
        const response = await axiosInstance.post(analyticsAPI.getPublisherEngagementDemographics, {
            dataFrequencyId: analyticsTimeframe,
            publisherId: publisherId
          });
        setDemographics(response.data);
        
    } catch (error) {
        console.error(error);
    } finally {
        setIsLoadingDemographics(false);
    }
  };

  const getPublishersAverageClicks = async () => {
    try {
        setIsLoadingAverageClicks(true);
        const response = await axiosInstance.post(analyticsAPI.getPublisherEngagementAverageClicks, {
            dataFrequencyId: analyticsTimeframe,
            publisherId: publisherId
          });
        setAverageClicks(response.data);
    } catch (error) {
        console.error(error);
    } finally {
        setIsLoadingAverageClicks(false);
    }
  };

  const getPublisherEngagementClickThroughRate = async () => {
    try {
        const response = await axiosInstance.post(analyticsAPI.getPublisherClickThroughRate, {
            dataFrequencyId: analyticsTimeframe,
            publisherId: publisherId
          });
        setClickThroughRate(response.data[0]);
    } catch (error) {
        console.error(error);
    } finally {
    }
  };

  useEffect(() => {
    if (!publisherId) return;
    getPublishersEngagementTopArticles();
    getPublisherEngagement();
    getPublisherEngagementTopicPercantage();
    getPublisherEngagementSearchTerms();
    getPublisherEngagementClickThroughRate();
    getPublisherEngagementDemographics();
    getPublishersAverageClicks();
  }, [analyticsTimeframe, publisherId]);

  return {
    timeframe: analyticsTimeframe,
    periodTimeFrame,
    publisherId,
    publisherName,
    publisherRole,
    roles,
    setPeriodTimeFrame: (timeframe) => {
      dispatch(setPeriodTimeFrame(timeframe));
    },
    setTimeframe: (timeframe) => {
      dispatch(setAnalyticsTimeframe(timeframe));
    },
    setPublisherId: (id) => {
      dispatch(setPublisherId(id));
    },
    publisherEngagement,
    clickThroughRate,
    topArticles,
    topicPercentage,
    topAuthors,
    searchTerms,
    demographics,
    averageClicks,
    isLoadingEngagement,
    isLoadingTopArticles,
    isLoadingTopicPercentage,
    isLoadingSearchTerms,
    isLoadingDemographics,
    isLoadingAverageClicks
  };
}
